export default "__VITE_ASSET__DCkoTO_W__"